import { CreateColumn } from '../../../Services/agGrid/createColumn';

const headerWrap = { wrapHeaderText: true, headerClass: 'ag-header-cell-wrap' };

/** content 열 헤더: 제보(1)·작업종료(3)→유해위험요인, 아차사고(2)→유해위험상황, 혼재 시 유해위험요인 */
const getHazardContentHeaderName = (api) => {
  if (!api?.forEachNodeAfterFilter) return '유해위험요인';
  let hasReport = false;
  let hasNearMiss = false;
  api.forEachNodeAfterFilter((node) => {
    if (!node?.data) return;
    const g = node.data.gubun;
    if (g === '2' || g === '아차사고 상황') hasNearMiss = true;
    else if (
      g === '1' ||
      g === '위험요인 제보' ||
      g === '3' ||
      g === '작업종료'
    )
      hasReport = true;
  });
  if (hasNearMiss && hasReport) return '유해위험요인';
  if (hasNearMiss) return '유해위험상황';
  return '유해위험요인';
};

export const getColumnDefs1 = (props) => [
  // NO 체크박스 (행 선택/삭제예정/복원)
  CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
    checkboxProps: {
      DeleteNewRow: props.DeleteNewRow1,
      RestoreRow: props.RestoreRow1,
      gridRef: props.gridRef1,
      rowData: props.rowData1,
      selectedRowNosRef: props.selectedRowNosRef1,
      lastCheckedIndexRef: props.lastCheckedIndexRef1,
      handleRowSelection: props.handleRowSelection1,
    },
    maxWidth: 100,
    ...headerWrap,
  }),
  // 순번 (nearMissSeq, 서버 저장 후 부여·키값, 읽기전용, 숨김)
  CreateColumn(
    'nearMissSeq',
    '순번',
    'center',
    80,
    false,
    false,
    false,
    'text',
    {
      hide: true,
      minWidth: 70,
      maxWidth: 100,
      cellClass: 'none-editable-cell',
      valueFormatter: (params) =>
        params.value != null && params.value !== '' ? params.value : '',
      ...headerWrap,
    }
  ),
  // 상태 (확인 전 / 완료, 셀렉트 박스: 0/1 코드 저장)
  CreateColumn('status', '상태', 'center', 100, true, false, false, 'text', {
    minWidth: 90,
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: ['0', '1'],
    },
    valueFormatter: (params) => {
      const v = params.value;
      if (v === '0' || v === '확인 전') return '확인 전';
      if (v === '1' || v === '완료') return '완료';
      return v || '';
    },
    ...headerWrap,
  }),
  CreateColumn(
    'workStartDate',
    '작업시작시간',
    'center',
    150,
    false,
    false,
    false,
    'datetime',
    {
      minWidth: 140,
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      cellClass: 'none-editable-cell',
      ...headerWrap,
    }
  ),
  CreateColumn(
    'workEndDate',
    '작업종료시간',
    'center',
    150,
    false,
    false,
    false,
    'datetime',
    {
      minWidth: 140,
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      cellClass: 'none-editable-cell',
      ...headerWrap,
    }
  ),
  // 구분 (셀렉트: 위험요인 제보 → '1', 아차사고 상황 → '2', 작업종료 → '3')
  CreateColumn('gubun', '구분', 'center', 140, true, true, false, 'text', {
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: ['위험요인 제보', '아차사고 상황', '작업종료'],
    },
    valueParser: (params) => {
      if (params.newValue === '위험요인 제보') return '1';
      if (params.newValue === '아차사고 상황') return '2';
      if (params.newValue === '작업종료') return '3';
      return params.newValue ?? '';
    },
    valueFormatter: (params) => {
      if (params.value === '1') return '위험요인 제보';
      if (params.value === '2') return '아차사고 상황';
      if (params.value === '3') return '작업종료';
      return params.value ?? '';
    },
    valueSetter: (params) => {
      const oldValue = params.data.gubun;
      let newValue = params.newValue;
      // 라벨 → 코드 보정
      if (newValue === '위험요인 제보') newValue = '1';
      else if (newValue === '아차사고 상황') newValue = '2';
      else if (newValue === '작업종료') newValue = '3';
      if (oldValue === newValue) return false;
      params.data.gubun = newValue;
      // 구분 변경 시 발생일시 초기화
      params.data.occurDate = '';
      params.data.editYn = 'Y';
      // 구분 값 변경 시 발생일시 컬럼의 편집 가능 여부/필수 표시를 즉시 반영
      params.api.refreshCells({
        rowNodes: [params.node],
        columns: ['occurDate'],
        force: true,
      });
      // content 컬럼 헤더(유해위험요인 ↔ 유해위험상황) 갱신
      if (typeof params.api.refreshHeader === 'function') {
        params.api.refreshHeader();
      }
      return true;
    },
    ...headerWrap,
  }),
  // 부서 (성명 설정 시 자동 입력)
  CreateColumn('depNm', '소속', 'left', 140, false, true, false, 'text', {
    minWidth: 120,
    cellClass: 'none-editable-cell',
    tooltip: '성명 설정 시 자동 입력됩니다.',
    ...headerWrap,
  }),
  // 직급 (성명 설정 시 자동 입력)
  CreateColumn('rank', '직위', 'left', 120, false, false, false, 'text', {
    minWidth: 110,
    cellClass: 'none-editable-cell',
    tooltip: '성명 설정 시 자동 입력됩니다.',
    ...headerWrap,
  }),
  // 작성자명 (기존 성명, 설정하기 버튼 → 회원정보 팝업)
  CreateColumn(
    'discovererNm',
    '작성자명',
    'center',
    130,
    false,
    true,
    false,
    'requiredButton',
    {
      buttonClickHandler: (params) => {
        if (params.data?.newYn === 'Y') {
          props.PopupClickEvent1?.(params);
        }
      },
      buttonEmptyText: '설정하기',
      buttonEmptyTooltip: '성명을 선택하세요.',
      buttonValueTooltip: (params) => {
        const isNew = params.data?.newYn === 'Y';
        return isNew
          ? '재설정 시 클릭하세요.'
          : '저장된 데이터는 수정할 수 없습니다.';
      },
      cellClassRules: {
        'required-cell': (params) => {
          const value = params.value;
          if (typeof value === 'string') return value.trim() === '';
          return !value;
        },
        'none-editable-cell': (params) => params.data?.newYn !== 'Y',
      },
      ...headerWrap,
    }
  ),
  // 공정(기인물) (설정하기 → GongjongSelectModal, 「기타 선택」·「선택 비우기」 지원)
  CreateColumn(
    'gongjongNm',
    '공정(기인물)',
    'left',
    180,
    false,
    false,
    false,
    'requiredButton',
    {
      flex: 1,
      minWidth: 180,
      buttonClickHandler: (params) => {
        props.PopupGongjongClickEvent1?.(params);
      },
      buttonEmptyText: '설정하기',
      buttonEmptyTooltip:
        '부서·공정을 고르거나, 목록에 없으면 모달의 「기타 선택」 후 발생장소에 위치를 상세히 적어 주세요. 「선택 비우기」로 공정을 비울 수 있습니다.',
      buttonValueTooltip: (params) => {
        const nm = params.value;
        const cd = params.data?.gongjongCd;
        const isOther = nm === '기타' || String(cd ?? '') === '0' || cd === 0;
        if (isOther) {
          return '「기타」(공정코드 0)입니다. 발생장소에 건물·층·구역 등 구체 위치를 입력했는지 확인하세요. 클릭하면 부서·공정을 다시 고를 수 있습니다.';
        }
        return nm
          ? '클릭 후 공정을 바꾸거나 「기타 선택」「선택 비우기」를 이용할 수 있습니다.'
          : '클릭하여 부서·공정을 선택하세요. 목록에 없으면 「기타 선택」 후 발생장소를 채워 주세요.';
      },
      ...headerWrap,
    }
  ),
  // 유해위험요인 / 유해위험상황 (구분에 따라 헤더 전환)
  CreateColumn(
    'content',
    '유해위험요인',
    'left',
    200,
    true,
    false,
    false,
    'text',
    {
      flex: 1,
      minWidth: 200,
      headerValueGetter: (params) => getHazardContentHeaderName(params?.api),
      ...headerWrap,
    }
  ),
  // 현재의 안전보건조치 (서버: TODAY_SAFETY / TodaySafety)
  CreateColumn(
    'todaySafety',
    '현재의 안전보건조치',
    'left',
    200,
    true,
    false,
    false,
    'text',
    {
      flex: 1,
      minWidth: 160,
      ...headerWrap,
    }
  ),
  // 위험성 감소대책 (서버: REDUCTION_MEASURES / ReductionMeasures)
  CreateColumn(
    'reductionMeasures',
    '위험성 감소대책',
    'left',
    200,
    true,
    false,
    false,
    'text',
    {
      flex: 1,
      minWidth: 160,
      ...headerWrap,
    }
  ),
  // 발생장소 (공정이 「기타」(코드 0)일 때 상세 위치 안내)
  CreateColumn(
    'location',
    '발생장소',
    'left',
    160,
    true,
    false,
    false,
    'text',
    {
      minWidth: 140,
      tooltipValueGetter: (params) => {
        const d = params.data;
        const isOther =
          d?.gongjongNm === '기타' ||
          String(d?.gongjongCd ?? '') === '0' ||
          d?.gongjongCd === 0;
        if (isOther) {
          return '공정이 「기타」(코드 0)일 때는 여기에 반드시 구체적인 위치를 적어 주세요. (예: 본관 2층 동쪽 복도, 야적장 A구역 북단)';
        }
        return '위험요인·아차사고가 발생한 장소를 입력합니다.';
      },
      ...headerWrap,
    }
  ),

  // 발생일시 (OccurDate, datetime)
  // - 구분 = '위험요인 제보'(1) : 수정 불가, 필수 아님
  // - 구분 = '아차사고 상황'(2) : 수정 가능, 저장 시 필수
  CreateColumn(
    'occurDate',
    '발생일시',
    'center',
    150,
    true,
    false,
    false,
    'datetime',
    {
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      minWidth: 150,
      // 구분 코드('2') 또는 라벨이 '아차사고 상황'인 경우에만 편집 가능
      editable: (params) => {
        const gubun = params.data?.gubun;
        return gubun === '2' || gubun === '아차사고 상황';
      },
      // not-allowed 상태일 때 사용자 안내 툴팁
      tooltipValueGetter: (params) => {
        const gubun = params.data?.gubun;
        if (gubun === '2' || gubun === '아차사고 상황') {
          return '';
        }
        return '발생일시는 "아차사고 상황"일 때만 입력 가능합니다.';
      },
      cellClassRules: {
        // 아차사고 상황(2) 인데 값이 없으면 필수 표시
        'required-cell': (params) => {
          const gubun = params.data?.gubun;
          const value = params.value;
          if (gubun !== '2') return false;
          if (typeof value === 'string') return value.trim() === '';
          return !value;
        },
        // 위험요인 제보(1) 이거나 기타일 때는 수정 불가 스타일
        'none-editable-cell': (params) => params.data?.gubun !== '2',
      },
      ...headerWrap,
    }
  ),
  // 개선전 사진 (파일 업로드 버튼)
  CreateColumn(
    'preFileNames',
    '개선 전 사진',
    'center',
    140,
    false,
    false,
    false,
    'fileButton',
    {
      fileButtonClickHandler: (data) => {
        props.PopupPreImageClickEvent1?.(data);
      },
      fileButtonEmptyText: '업로드',
      fileButtonValueText: '사진확인하기',
      ...headerWrap,
    }
  ),
  // 고치결과
  CreateColumn(
    'resultContent',
    '조치결과',
    'left',
    200,
    true,
    false,
    false,
    'text',
    {
      flex: 1,
      minWidth: 200,
      ...headerWrap,
    }
  ),
  // 담당자 (작성자명과 동일하게 설정하기 버튼 → 회원정보 팝업)
  CreateColumn(
    'managerNm',
    '담당자',
    'center',
    130,
    false,
    false,
    false,
    'requiredButton',
    {
      buttonClickHandler: (params) => {
        props.PopupClickEvent1?.(params);
      },
      buttonEmptyText: '설정하기',
      buttonEmptyTooltip: '담당자를 선택하세요.',
      buttonValueTooltip: () => '재설정 시 클릭하세요.',
      ...headerWrap,
    }
  ),
  // 조치일자
  CreateColumn(
    'resultDate',
    '조치일자',
    'center',
    120,
    true,
    false,
    false,
    'date',
    {
      minWidth: 110,
      dateFormat: 'YYYY-MM-DD',
      ...headerWrap,
    }
  ),
  // 개선 후 사진 (파일 업로드 버튼)
  CreateColumn(
    'postFileNames',
    '개선 후 사진',
    'center',
    160,
    false,
    false,
    false,
    'fileButton',
    {
      fileButtonClickHandler: (data) => {
        props.PopupPostImageClickEvent1?.(data);
      },
      fileButtonEmptyText: '업로드',
      fileButtonValueText: '사진확인하기',
      ...headerWrap,
    }
  ),

  // 비고
  CreateColumn('remark', '비고', 'left', 180, true, false, false, 'text', {
    flex: 1,
    minWidth: 120,
    ...headerWrap,
  }),
];
